import React, { createContext } from 'react';

export const GlobalContext = createContext({
  config: {},
  person: {},
  devmode: false,
  globalError: '',
  errStamp: 0,
  appMode: null,
  project: {},
  updatePerson: () => {},
  updateProject: () => {},
  updateUserQuery: () => {},
  userQuery: {},
});

export default class GCProvider extends React.Component {
  updatePerson = async () => {
    let res = await fetch('/api/authuser', {
        credentials: "same-origin",
    });
    if (res && res.ok) {
      let person = await res.json();
      const { devmode } = this.state;
      devmode && console.log("Authuser:", person);
      this.setState({person});
    }
  };

  updateProject = (project) => {
    this.setState({project});
  }

  updateUserQuery = (user) => {
    this.setState({userQuery: user});
  }

  updateUserQuery = async (user) => {
    let updatedUser = user;
    if (user !== null && user.email) {
      let res = await fetch(`/api/log/${user.email}`, {
          credentials: "same-origin",
      });
      if (res && res.ok) {
        let l = await res.json();
        const logs = l.entries ? l.entries : []
        const { devmode } = this.state;
        devmode && console.log("Log:", logs);
        updatedUser.logs = logs;
      }
    }
    this.setState({userQuery: updatedUser});
  };

  setGlobalError = (globalError) => {
    const errStamp = Math.floor(new Date().getTime()/1000)
    this.setState({ globalError, errStamp })
  }

  setAppMode = (appMode) => {
    this.setState({ appMode })
  }

  // TODO: redundant fetch calls - do we care?
  componentDidMount() {
    let devmode = false;
    if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
      devmode = true
    }
    let config, person;
    fetch('/api/config', {
        credentials: "same-origin",
    })
    .then((res) => res.json())
    .then((data) => {
        config = data;
        devmode && console.log("Config", config)
    })
    .then(() =>
        fetch('/api/authuser', {
            credentials: "same-origin",
        })
    )
    .then((res) => res.json())
    .then((data) => {
        person = data;
        devmode && console.log("Authuser:", person)
    })
    .then(() => {
        this.setState({ config, person, devmode });
    })
    .catch((error) => {
        console.log("Error on initial load: ", error)
        this.setState({ globalError: error});
    });
  }

  state = {
    config: null,
    person: null,
    project: null,
    globalError: null,
    appMode: null,
    updatePerson: this.updatePerson,
    updateProject: this.updateProject,
    updateUserQuery: this.updateUserQuery,
    userQuery: null,
    setGlobalError: this.setGlobalError,
    setAppMode: this.setAppMode,
  };

  render() {
    if (this.state.config == null) {
        return null
    }
    return (
      <GlobalContext.Provider value={this.state}>
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}

// Can be used with render props
export const GCConsumer = GlobalContext.Consumer;
